//Remember to announce new sections/lead forms to the frontend team & analytics team to get new GTM values
export const enum GTMEventApplicationSourceSection {
    HEADER = "header",
    IMAGE = "image",
    BUTTON = "button",
    BANNER = "banner",
    BUTTON_STICKY_BAR = "button_sticky_bar",
    ZOOM_MAP = "zoom_map",
    BUTTON_MAP = "button_map",
    HEADER_LEAD = "header_zapytaj",
    HEADER_CALL = "header_zadzwoń",
    TILE = "kafel",
    PROPERTY_LIST_PRICE = "property_list_price",
    PROPERTY_LIST_PRICE_MAP = "property_list_price_mapa",
    ADDITIONAL_PROPERTY_LIST_PRICE = "additional_property_list_price",
    HEADER_NEGOTIATE = "header_negocjuj",
    BOTTOM_NEGOTIATE = "bottom_negocjuj",
    SIDEBAR_LEAD = "sidebar_zapytaj",
    SIDEBAR_ARRANGE_MEETING = "sidebar_umów",
    TILE_OTHERS = "kafel_inne",
    CREDIT = "kredyt",
    COMPARISON_TOOL = "porównywarka",
    OFFER_WEBSITE = "strona_internetowa_inwestycji",
    TILE_LISTING_MAP = "kafel_listing_mapa",
    PROMOTION = "promocja",
    PROPERTY_CONFIGURATOR = "konfigurator",
    LISTING_REELS = "rolka_listing",
    SIDEBAR_MY_LIST = "sidebar_moja_lista",
    SIDEBAR_MAP_DETAIL = "sidebar_detail_mapa",
    CONTACT_VENDOR_PAGE = "contact_vendor_page",
    CHATBOT_MODAL = "chatbot_modal",
    MODAL_GALLERY = "modal_detail_galeria",
    MODAL_CONSTRUCTION_GALLERY = "modal_detail_zdjęcia_budowa",
    MODAL_FLOOR_PLAN = "modal_detail_plan",
    MODAL_MAP = "modal_detail_mapa",
    CPL_MODAL = "modal_cpl",
    SHOW_SIMILAR_OFFERS = "zobacz_podobne_oferty",
    PRICE_HISTORY = "historia_cen"
}
//Remember to announce new sections/lead forms to the frontend team & analytics team to get new GTM values
export const enum GTMEventApplicationSourceSection {
    HEADER = "header",
    IMAGE = "image",
    BUTTON = "button",
    BANNER = "banner",
    BUTTON_STICKY_BAR = "button_sticky_bar",
    ZOOM_MAP = "zoom_map",
    BUTTON_MAP = "button_map",
    HEADER_LEAD = "header_zapytaj",
    HEADER_CALL = "header_zadzwoń",
    TILE = "kafel",
    PROPERTY_LIST_PRICE = "property_list_price",
    PROPERTY_LIST_PRICE_MAP = "property_list_price_mapa",
    ADDITIONAL_PROPERTY_LIST_PRICE = "additional_property_list_price",
    HEADER_NEGOTIATE = "header_negocjuj",
    BOTTOM_NEGOTIATE = "bottom_negocjuj",
    SIDEBAR_LEAD = "sidebar_zapytaj",
    SIDEBAR_ARRANGE_MEETING = "sidebar_umów",
    TILE_OTHERS = "kafel_inne",
    CREDIT = "kredyt",
    COMPARISON_TOOL = "porównywarka",
    OFFER_WEBSITE = "strona_internetowa_inwestycji",
    TILE_LISTING_MAP = "kafel_listing_mapa",
    PROMOTION = "promocja",
    PROPERTY_CONFIGURATOR = "konfigurator",
    LISTING_REELS = "rolka_listing",
    SIDEBAR_MY_LIST = "sidebar_moja_lista",
    SIDEBAR_MAP_DETAIL = "sidebar_detail_mapa",
    CONTACT_VENDOR_PAGE = "contact_vendor_page",
    CHATBOT_MODAL = "chatbot_modal",
    MODAL_GALLERY = "modal_detail_galeria",
    MODAL_CONSTRUCTION_GALLERY = "modal_detail_zdjęcia_budowa",
    MODAL_FLOOR_PLAN = "modal_detail_plan",
    MODAL_MAP = "modal_detail_mapa",
    CPL_MODAL = "modal_cpl",
    SHOW_SIMILAR_OFFERS = "zobacz_podobne_oferty",
    PRICE_HISTORY = "historia_cen"
}
